/**
 * Created by rongzhx on 2017/9/9 0009.
 */
import React, { Component, PureComponent } from 'react';
import { Spin } from 'antd';
import './index.less';

class Loading extends (PureComponent || Component) {
  state = {
  	loading: false
  }

  componentDidMount () {
  	const { loading } = this.props;
  	if (loading) {
  		this.setState({ loading: true });
  	} else {
  		this.setState({ loading: false });
  	}
  }

  componentWillReceiveProps (nextProps) {
  	let { loading } = nextProps;

  	if (loading === true || loading === 'true') {
  		loading = true;
  	} else {
  		loading = false;
  	}
  	this.setState({ loading });
  }

  render () {
  	const prefixCls = 'eh-loading-component';
  	const { loading } = this.state;
  	let { coverScope = false, style = {} } = this.props;
  	return (
  		loading ? <div className={prefixCls} /**style={{ top: coverScope ? 194 : 140, ...style }}*/>
  			<div className={`${prefixCls}-inner`}>
  				<Spin spinning={loading} />
  			</div>
  		</div> : null
  	);
  }
}

export default Loading;
